const urlName = '/usercenter/v1'
const marketingUrl = '/marketing-mix/v1'
export default API => ({
    // 退出登录
    logout({data, params}) {
        return API({
            url: `${urlName}/account/logout` ,
            method:  'post',
            data,
            params
        });
    },
    // 分校列表
    getFindUserBranchList({data, params}) {
        return API({
            url: `${urlName}/account/findUserBranchList` ,
            data,
            params
        });
    },
    // 列表
    accountProfile(id) {
        return API({
            url: `${urlName}/accountProfile/findById?id=${id}` ,
            method:  'get',
        });
    },
    
    accountProfileSave(data) {
        return API({
            url: `${urlName}/accountProfile/updateAccountInfo` ,
            method:  'post',
            data
        });
    },
    // 个人资料
    findUserDetail() {
        return API({
            url: `company/v1/user/findMyDetail` ,
            method:  'get'
        });
    },
    //编辑保存个人资料
    userDetailSave(data) {
        return API({
            url: `company/v1/user/save` ,
            method:  'post',
            data
        });
    },
    //获取城市列表
    getRegionList() {
        return API({
            url: `company/v1/region/regionList` ,
            method:  'get'
        });
    },


    //订单详情
    getOrderList(data,params) {
        return API({ 
            url: `/order/v1/open/order/myOrderListWithPage?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, 
            method:  'get',
            params: data,
        });
    },
    // 电子凭证
    htmlToPdf ({params,data}) {
        return API({ 
            url: '/saas/v1/offlineOrder/certificate',
            method: 'post',
            params,
            data
        })
    },
    // 线下订单列表
    getOfflineOrder ({params,data}) {
        return API({ 
            url: '/saas/v1/offlineOrder/find',
            method: 'post',
            params,
            data
        })
    },
    getOfflineOrderInfo ({params,data}) {
        return API({ 
            url: '/saas/v1/offlineOrder/findById',
            method: 'get',
            params,
            data
        })
    },

    //我的总积分
    getYxtIntegralInfoCount({params}) {
        return API({ 
            url: `/saas/v1/yxt/jf/getYxtIntegralInfoCount`, 
            method:  'get',
            params,
        });
    },
    //我的积分
    getYxtIntegralInfo({params}) {
        return API({ 
            url: `/saas/v1/yxt/jf/getYxtIntegralInfo`, 
            method:  'get',
            params,
        });
    },
    // 优惠券列表
    getUserCouponList(data) {
        return API({
            url: `${marketingUrl}/couponUser/findByCondition`,
            method: 'post',
            data,
            headers:{
                'Content-Type': 'application/json',
            }
        });
    },
    getCouponList(data) {
        return API({
            url: `${marketingUrl}/coupon/findByCondition`,
            method: 'post',
            data,
            headers:{
                'Content-Type': 'application/json',
            }
        });
    },
    // 可用优惠券列表（订单确认页）
    getUseCoupon(params) {
        return API({
            url: `${marketingUrl}/couponUser/availableCouponList`,
            params,
        });
    },
    // 优惠券领取
    getCoupon(params) {
        return API({
            url: `${marketingUrl}/couponUser/receive`,
            method: 'get',
            params,
        });
    },

    // 优惠券使用
    useCoupon(params) {
        return API({
            url: `${marketingUrl}/coupon/getroute`,
            params,
        });
    },
    // 计算使用优惠券
    useCouponPrice(data) {
        return API({
            url: `${marketingUrl}/client/couponAndCode/getPriceByGoodsInfo`,
            method: 'post',
            data
        });
    },
    // 兑换
    getExChangeList(data) {
        return API({
            url: `${marketingUrl}/client/exchangecode/detailByCode`,
            method: 'post',
            data
        });
    },
    exchangeCode(data) {
        return API({
            url: `${marketingUrl}/client/exchangecode/useByCode`,
            method: 'post',
            data
        });
    },
    verifyExchangeCode(params) {
        return API({
            url: `${marketingUrl}/admin/exchangecode/verifyToUse`,
            params
        });
    },
    setChannel(data) {
        return API({
            url: '/mks/v1/userRegisterSource/updateRegisterUserChannel',
            method: 'post',
            data
        });
    },
    // 活动优惠券领取
    activityReceive(data) {
        return API({
            url: '/marketing-mix/v1/couponUser/activityReceive',
            method: 'post',
            data
        });
    },
    // 查询当前身份信息是否已经绑定账号
    findIdcardAuth(params){
        return API({
            url: '/usercenter/v1/account/findIdcardAuth',
            params
        });
    },
    // 解除当前账号绑定的身份信息
    cancleAuth(){
        return API({
            url: '/usercenter/v1/account/cancleAuth',
        });
    }
})
